"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSubscription = createSubscription;
exports.getIndividualCoachingBookings = getIndividualCoachingBookings;
exports.getSubscriptionById = getSubscriptionById;
exports.getSubscriptionList = getSubscriptionList;
exports.getSubscriptionStatistics = getSubscriptionStatistics;
exports.getSubscriptionUserRecords = getSubscriptionUserRecords;
exports.getSubscriptionUserRecordsStatistics = void 0;
exports.updateSubscription = updateSubscription;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.keys.js");
var _request = _interopRequireDefault(require("@/utils/request"));
function createSubscription(token, data) {
  var headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/v1/subscriptions',
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'post',
    headers: headers,
    data: data
  });
}
function getSubscriptionList(token, query) {
  var headers = {
    'Authorization': 'Bearer ' + token
  };
  var config = {
    url: '/v1/subscriptions',
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'get',
    headers: headers
  };
  if (query && Object.keys(query).length > 0) {
    config.params = query;
  }
  return (0, _request.default)(config);
}
function getSubscriptionById(token, id) {
  var headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/v1/subscriptions/' + id,
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'get',
    headers: headers
  });
}
function updateSubscription(token, id, data) {
  var headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/v1/subscriptions/' + id,
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'put',
    headers: headers,
    data: data
  });
}
function getSubscriptionUserRecords(token, id) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/subscriptions/' + id + '/user-records',
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers: headers,
    params: params
  });
}
function getIndividualCoachingBookings(token, subscriptionId, userUuid) {
  var headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: "/subscriptions/".concat(subscriptionId, "/individual-coaching-bookings/").concat(userUuid),
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers: headers
  });
}
function getSubscriptionStatistics(token, id) {
  var headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/subscriptions/' + id + '/statistics',
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers: headers
  });
}
var getSubscriptionUserRecordsStatistics = exports.getSubscriptionUserRecordsStatistics = getSubscriptionStatistics;